import { useCallback } from 'react';
import { useAuthenticatedAPI } from '../../../state';
import { useWizardParams } from '../selectors';
export var COPY_PART_TIME_API = '/api/partTime/{dest}';
export var CLEAR_PART_TIME_API = '/api/partTime/{queueId}';
export var useCopyPartTimeAPI = function () {
  var dest = useWizardParams().queueId;
  var _a = useAuthenticatedAPI(COPY_PART_TIME_API, {
      dest: dest
    }, 'POST'),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function (source) {
    if (dest) fetchData(undefined, {
      source: source
    });
  }, [fetchData, dest]);
  return [data, fetchDataWrapper, clearData];
};
export var useClearPartTimeAPI = function () {
  var queueId = useWizardParams().queueId;
  var _a = useAuthenticatedAPI(CLEAR_PART_TIME_API, {
      queueId: queueId
    }, 'DELETE'),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function () {
    if (queueId) fetchData();
  }, [fetchData, queueId]);
  return [data, fetchDataWrapper, clearData];
};